export default [
  {
    displayText: 'Any',
    value: '', // TODO: use null rather than '' when queryGenerator is fixed
  }, {
    displayText: '50 m²',
    value: 50,
  }, {
    displayText: '100 m²',
    value: 100,
  }, {
    displayText: '150 m²',
    value: 150,
  }, {
    displayText: '200 m²',
    value: 200,
  }, {
    displayText: '250 m²',
    value: 250,
  }, {
    displayText: '300 m²',
    value: 300,
  }, {
    displayText: '350 m²',
    value: 350,
  }, {
    displayText: '400 m²',
    value: 400,
  }, {
    displayText: '500 m²',
    value: 500,
  }, {
    displayText: '750 m²',
    value: 750,
  }, {
    displayText: '1,000 m²',
    value: 1000,
  }, {
    displayText: '1,500 m²',
    value: 1500,
  }, {
    displayText: '2,000 m²',
    value: 2000,
  }, {
    displayText: '3,000 m²',
    value: 3000,
  }, {
    displayText: '5,000 m²',
    value: 5000,
  }, {
    displayText: '10,000 m²',
    value: 10000,
  }, {
    displayText: '20,000 m²',
    value: 20000,
  },
];
